export interface IWorkstationInfoModel {
  workstationID: number;
  workstationType: WorkstationType;
  branchID: number;
  autoScaleEnabled: boolean;
}

export enum WorkstationType  {
  RXSatellitBlockad= -20,
  RXSingelBlockad= -10,
  RXBlockad= -2,
  PackBlockad= -1,
  unknown= 0,
  Pack= 1,
  RX= 2,
  RXAuto = 3,
  RXsingel= 10,
  RXSatellit= 20,
  AFrame= 30,
  AutoPackSmall= 33,
  AutoPackMedium= 36,
  AutoPackLarge=60,
  AutoPackXLarge= 70,
  AutoPackMixedSmall= 73,
  AutoPackWestMixedSmall= 74,
  AutoPackMixedMedium=76,
  AutoPackWestMixedMedium= 77,
  Review= 99,
};

export class WorkstationInfoModel implements IWorkstationInfoModel {
  workstationID = -1;
  workstationType = 0;
  branchID = -1;
  autoScaleEnabled = false;

  constructor(
    workstationID: number,
    workstationType: number,
    branchID: number,
    autoScaleEnabled: boolean = false
  ) {
    this.workstationID = workstationID;
    this.workstationType = workstationType;
    this.branchID = branchID;
    this.autoScaleEnabled = autoScaleEnabled;
  }
}
